





















































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast } from 'vant';
import { TbGoodsClass, TbGrade, TbMember } from "@/http";
import { dialogPanel, vipGradePanel, birthdayPanel, logoutPanel } from "@/components";
import dayjs from 'dayjs';
@Component({
    components: { dialogPanel, vipGradePanel, birthdayPanel, logoutPanel },
})
export default class addVipPanel extends Vue {

    public $refs!: {

    };

    @Prop({
        default: false
    })
    show: Boolean;
    @Prop({
        default: true
    })
    isAdd: Boolean;


    @Watch('isParent')
    isParentChange(val) {
        this.title = this.isAdd ? '新增会员' : '编辑会员';
    }
    title = "新增会员";

    isloading = false;
    isloading2 = false;

    form: any = {
        name: "",
        phone: "",
        sex: 0,
        birthdayTime: '',
        gradeId: "",
    }
    gradeName = "";
    gradeDiscount = null;
    config = {
        loop: [
            {
                number: 1,
                key: 'number-1',
            },
            {
                number: 2,
                key: 'number-2',
            },
            {
                number: 3,
                key: 'number-3',
            },
            {
                number: 4,
                key: 'number-4',
            },
            {
                number: 5,
                key: 'number-5',
            },
            {
                number: 6,
                key: 'number-6',
            },
            {
                number: 7,
                key: 'number-7',
            },
            {
                number: 8,
                key: 'number-8',
            },
            {
                number: 9,
                key: 'number-9',
            },
        ]
    }

    value = null;
    maxLength = 16;

    userInfo: any = {};

    /**提示弹窗 */
    tipShow = false;
    tipTitle = "";
    tipText = "";
    confirmText = "";
    cancelText = "";
    btnNums = 1;
    tipType = 1;
    GradeList: any = []
    showGradPopover = false
    changeGradXL(item, index) {
        console.log('item', item)
        this.form.gradeId = item.id
        this.gradeName = item.name;
        this.gradeDiscount = item.discount;
        this.showGradPopover = false
    }

    get getNameDiscount() {
        let str = "";
        if (this.gradeDiscount) {
            str = this.gradeName == '普通会员' ? "普通会员(无折扣)" : this.gradeName + `(${this.gradeDiscount.toFixed(1)}折)`
        }
        return str;
    }


    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
        this.title = this.isAdd ? '新增会员' : '编辑会员';
        // if (this.isAdd) {
        this.getGradeList();
        // }
    }
    async created() {

    }

    async getGradeList() {
        let res = await TbGrade.GetGradeList();
        this.GradeList = res.map(v => {
            return {
                ...v,
                nameDiscount: v.name == '普通会员' ? v.name + '(无折扣)' : v.name + `(${v.discount.toFixed(1)}折)`
            }
        });
        if (this.isAdd) {
            let index = res.findIndex(v => v.isInitial);
            if (index > -1) {
                this.form.gradeId = res.find(v => v.isInitial).id;
                this.gradeName = res.find(v => v.isInitial).name;
                this.gradeDiscount = res.find(v => v.isInitial).discount;
            } else {
                this.form.gradeId = res.find(v => v.name == '普通会员').id;
                this.gradeName = '普通会员';
                this.gradeDiscount = res.find(v => v.name == '普通会员').discount;
            }
        }

    }

    async init(item) {
        this.form = item;
        this.value = this.form.phone;
        let res = await TbGrade.GetGradeList();
        let index = res.findIndex(v => v.id == this.form.gradeId);
        if (index > -1) {
            this.form.gradeId = res.find(v => v.id == this.form.gradeId).id;
            this.gradeName = res.find(v => v.id == this.form.gradeId).name;
            this.gradeDiscount = res.find(v => v.id == this.form.gradeId).discount;
        } else {
            this.form.gradeId = res.find(v => v.name == '普通会员').id;
            this.gradeName = '普通会员';
            this.gradeDiscount = res.find(v => v.name == '普通会员').discount;
        }
    }

    async saveFun(val) {
        if (!this.form.phone) {
            Toast("请输入手机号");
            return;
        }
        if (this.isloading) return;
        this.isloading = true;
        if (this.isAdd) {
            try {
                let obj = Object.assign({}, this.form, {
                    shopId: this.userInfo.shopId,
                })
                let res = await TbMember.PostTbMember(obj);
                this.isloading = false;
                Toast("新增成功")
                if (val) {
                    this.closeFun();
                } else {
                    this.closeFun();
                    /**去充值 */
                    this.$router.push(`/pad/vip/recharge?id=${res.memberId}`);
                }
                this.$emit("confirmSave", res);
            } catch (error) {
                this.isloading = false;
            }
        } else {
            try {
                let res = await TbMember.PutTbMember(this.form);
                Toast('保存成功')
                this.isloading = false;
                this.closeFun();
                this.$emit("confirmSave", res);
            } catch (error) {
                this.isloading = false;
            }
        }

    }
    resetForm() {
        this.form = {
            name: "",
            phone: "",
            sex: 0,
            birthdayTime: '',
            gradeId: "",
        }
    }

    closeFun() {
        this.resetForm();
        this.$emit("closeFun");
    }
    showGrade() {
        this.$refs['vipGradePanel'].showFun(this.form.gradeId)
    }
    vipGradeConfirm(val) {
        this.form.gradeId = val.id;
        this.gradeName = val.name;
        this.gradeDiscount = val.discount;
    }
    changeSex(val) {
        this.form.sex = val;
    }
    showBirthday() {
        this.$refs['birthdayPanel'].showFun();
    }
    birthdyConfirm(val) {
        this.form.birthdayTime = dayjs(val).format("MM-DD");
        console.log('va', this.form.birthdayTime);
    }

    del() {
        if (!this.value) return;
        let index = this.value.length;
        this.value = this.value.toString().slice(0, index - 1);
        this.finishFun();
    }
    number(number) {
        // this.$emit("number", number);
        let val = this.value;
        let dotIndex = this.value ? this.value.toString().indexOf('.') : -1;
        if (number == '.' && dotIndex > -1 || this.value && this.value.toString().length == this.maxLength) return;
        this.value = this.value ? this.value.toString() + number.toString() : number.toString();
        if (dotIndex > -1) {
            if (val.toString().slice(dotIndex + 1).length > 1) {
                this.value = this.value.slice(0, dotIndex + 3)
            }
        } else {
            this.value = this.value.slice(0, this.maxLength)
        }
        this.finishFun();
    }


    clearFun() {
        this.value = null;
        this.finishFun();
    }
    finishFun() {
        this.form.phone = this.value;
    }
    async deleteFun() {
        if (this.form.integral || this.form.balance) return;

        this.tipTitle = "操作提醒";
        this.tipText = `确认要删除此会员吗？`;
        this.btnNums = 2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;


    }
    /**提示弹窗 */
    async tipConfirm() {
        switch (this.tipType) {
            /**删除会员 */
            case 1:
                this.confirmDelete();
                break;


            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel() {
        this.tipShow = false;
    }
    async confirmDelete() {
        if (this.isloading2) return;
        this.isloading2 = true;
        try {
            let res = await TbMember.DeleteMemberList({ ids: [this.form.id] });
            this.$emit("confirmSave", null);
            Toast('删除成功');
            this.closeFun();
            this.isloading2 = false;
        } catch (error) {
            this.isloading2 = false;

        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/components/addVipPanel.vue